import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { stripeCheckoutStatusSchema } from "../billing/stripeCheckout.mjs";
import { z as z$1 } from "zod";

// src/models/projections/stripeCheckoutProjection.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Fixed doc id under `consultations/{consultationId}/projections/stripeCheckout`. */
const STRIPE_CHECKOUT_PROJECTION_KEY = "stripeCheckout";
const STRIPE_NOSHOW_FEE_CHECKOUT_PROJECTION_KEY = "stripeNoshowFeeCheckout";
const STRIPE_SETTLEMENT_PAYMENT_CHECKOUT_PROJECTION_KEY = "stripeSettlementPaymentCheckout";
/**
* Lean FE mirror for clinical Stripe checkout at reserve/begin_payment.
* Path: `consultations/{consultationId}/projections/stripeCheckout`.
*/
const stripeCheckoutProjectionSchema = z$1.object({
	id: zodFlavorId(),
	checkoutSyncId: zodFlavorId().optional(),
	status: stripeCheckoutStatusSchema.optional(),
	paid: z$1.boolean().optional(),
	/** True when projection reflects current control-plane binding + observed checkout. */
	inSync: z$1.boolean().default(false),
	createdAt: firestoreDate,
	updatedAt: firestoreDate
});
/** Pub/Sub ordering key for stripeCheckout projection resolve. */
function buildStripeCheckoutProjectionOrderingKey(consultationId) {
	return `consultations/${consultationId}/projections/${STRIPE_CHECKOUT_PROJECTION_KEY}`;
}
function buildStripeNoshowFeeCheckoutProjectionOrderingKey(consultationId) {
	return `consultations/${consultationId}/projections/${STRIPE_NOSHOW_FEE_CHECKOUT_PROJECTION_KEY}`;
}
function buildStripeSettlementPaymentCheckoutProjectionOrderingKey(consultationId) {
	return `consultations/${consultationId}/projections/${STRIPE_SETTLEMENT_PAYMENT_CHECKOUT_PROJECTION_KEY}`;
}

export { STRIPE_CHECKOUT_PROJECTION_KEY, STRIPE_NOSHOW_FEE_CHECKOUT_PROJECTION_KEY, STRIPE_SETTLEMENT_PAYMENT_CHECKOUT_PROJECTION_KEY, buildStripeCheckoutProjectionOrderingKey, buildStripeNoshowFeeCheckoutProjectionOrderingKey, buildStripeSettlementPaymentCheckoutProjectionOrderingKey, stripeCheckoutProjectionSchema };
//# sourceMappingURL=stripeCheckoutProjection.mjs.map